import Spinner from '@components/icons/Spinner';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';

export const VerifyingLink = () => (
  <>
    <Header as="h1">Verifying Link</Header>
    <Body1>You will be redirected to your dashboard soon.</Body1>
    <Spinner />
  </>
);
